var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.5 6.93994C2.5 5.53981 2.5 4.83974 2.77248 4.30497C3.01217 3.83456 3.39462 3.45211 3.86502 3.21243C4.3998 2.93994 5.09987 2.93994 6.5 2.93994H13.5C14.9001 2.93994 15.6002 2.93994 16.135 3.21243C16.6054 3.45211 16.9878 3.83456 17.2275 4.30497C17.5 4.83974 17.5 5.53981 17.5 6.93994V13.9399C17.5 15.3401 17.5 16.0401 17.2275 16.5749C16.9878 17.0453 16.6054 17.4278 16.135 17.6675C15.6002 17.9399 14.9001 17.9399 13.5 17.9399H6.5C5.09987 17.9399 4.3998 17.9399 3.86502 17.6675C3.39462 17.4278 3.01217 17.0453 2.77248 16.5749C2.5 16.0401 2.5 15.3401 2.5 13.9399V6.93994Z",
    stroke: "#1E1A21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.93c30c193b09a2fa728f6d568f8e6821.svg";
export { ForwardRef as ReactComponent };